export const sortStates = (statesArray) => {
  return statesArray
    .map((state) => state.label)
    .sort()
    .map((state) => ({
      label: state,
      value: state,
    }));
};
